import { useState } from "react";
import Button from "../components/common/Button";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useConfirmPaymentMutation } from "../store";
import { useNavigate } from "react-router-dom";
import { showToast, ToastType } from "../utils/toast.utils";

const CheckoutForm: React.FC<{ orderId: string }> = ({ orderId }) => {
  const [confirmPayment, { isLoading }] = useConfirmPaymentMutation();
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/success?orderId=${orderId}`,
      },
      redirect: "if_required",
    });

    if (error) {
      showToast(error.message || "une erreur s'est produite", ToastType.ERROR);
      setIsProcessing(false);
    } else if (paymentIntent && paymentIntent.status === "succeeded") {
      const { error } = await confirmPayment({
        paymentIntentId: paymentIntent.id,
      });
      if (!error) {
        navigate("/success?orderId=" + orderId);
      }
    } else {
      showToast(
        "une erreur s'est produite, veuillez réessayer plus tard",
        ToastType.ERROR
      );
      setIsProcessing(false);
    }
  };
  return (
    <form
      id="payment-form"
      onSubmit={handleSubmit}
    >
      <PaymentElement />
      <Button
        disabled={isProcessing || isLoading}
        id="submit"
        className="bg-primary text-white w-full text-center rounded p-1 my-2"
      >
        <span className="text-center w-full font-semibold text-lg">
          {isProcessing || isLoading ? "Traitement en cours" : "Payer"}
        </span>
      </Button>
    </form>
  );
};

export default CheckoutForm;
